import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { NeuButton, NeuSelect } from "../../components/neu/Neu";
import { requestApproval } from "../../api/supplierPayables";
import client from "../../api/client";

export const RequestApprovalDialog = ({ payable, open, onOpenChange, onDone }) => {
  const { t } = useTranslation();
  const [boxes, setBoxes] = useState([]);
  const [cashbox, setCashbox] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    client.get("/accounting/cashboxes").then((r) => setBoxes(r.data || []));
  }, [open]);

  const submit = async () => {
    if (!cashbox) return toast.error(t("acct.dues.dlg.pickCashbox"));
    setBusy(true);
    try {
      await requestApproval(payable.id, cashbox);
      toast.success(t("acct.dues.dlg.sent"));
      onDone?.();
      onOpenChange(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail?.code || "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl">
        <DialogHeader>
          <DialogTitle>{t("acct.dues.dlg.title")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">{t("acct.dues.dlg.pickCashbox")}</p>
          <NeuSelect data-testid="dlg-cashbox" value={cashbox} onChange={(e) => setCashbox(e.target.value)}>
            <option value="">{t("app.none")}</option>
            {boxes.map((b) => (
              <option key={b.id} value={b.id}>{b.name} — {b.balance} {b.currency || ""}</option>
            ))}
          </NeuSelect>
        </div>
        <DialogFooter>
          <NeuButton onClick={submit} disabled={busy} data-testid="dlg-submit">
            {t("acct.dues.dlg.submit")}
          </NeuButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
